// src/Components/SubscriptionBanner.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './SubscriptionBanner.css';

const dynamicWords = ['Trust', 'Taste', 'Love', 'Quality'];

const SubscriptionBanner = () => {
  const [wordIndex, setWordIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState('');
  const wordSpanRef = useRef(null);

  useEffect(() => {
    setAnimationClass('fade-in');

    const wordChangeInterval = setInterval(() => {
      setAnimationClass('fade-out');

      setTimeout(() => {
        setWordIndex(prevIndex => (prevIndex + 1) % dynamicWords.length);
        setAnimationClass('');

        setTimeout(() => {
          if (wordSpanRef.current) void wordSpanRef.current.offsetWidth;
          setAnimationClass('fade-in');
        }, 50);
      }, 500);
    }, 2500);

    return () => clearInterval(wordChangeInterval);
  }, []);

  return (
    <section className="subscribe-section">
      <div className="subscribe-container">
        <div className="subscribe-content">
          <h1 className="subscribe-title">
            <div className="dynamic-word-container">
              <span ref={wordSpanRef} className={`dynamic-word ${animationClass}`}>
                {dynamicWords[wordIndex]}
              </span>
            </div>
            <div className="highlight-text">Beyond Every Bite</div>
          </h1>
          <p className="subscribe-subtitle">
            Customized to your taste, schedule, and lifestyle.
          </p>
          <Link to="/package" className="subscribe-button">Subscribe now</Link>
        </div>

        <div className="subscribe-image-wrapper">
          <img
            src="/assets/images/homepage-one/girl-eating-meal.png"
            alt="Girl enjoying a home-cooked meal"
            className="hero-image"
          />
          {/* Testimonial bubbles */}
          <div className="testimonial-bubble bubble-1">
            No Repeated <span className="diamond">and</span> Boring Menu
          </div>
          <div className="testimonial-bubble bubble-2">
            Consistent Taste <span className="diamond">and</span> Fresh & Clean
          </div>
        </div>
      </div>

      {/* Info banner */}
      <div className="info-banner">
        <div className="marquee-container">
          <h2>Every Dish is Cooked With Care<span className="marquee-diamond">✨</span>  Bringing You Comfort</h2>
          <h2><span className="marquee-diamond"> ✨</span> Taste Like Home</h2>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionBanner;